module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.d84d36e.woff2";